import React, { useState } from 'react';
import { MenuItemInterface } from 'utils/types/oraclePayment/MenuItem';

interface UseViewModelProps {
  menuItems: MenuItemInterface[];
}

const useViewModel = ({ menuItems }: UseViewModelProps) => {
  const [showLessItemAmount, setShowLessItemAmount] = useState(false);
  const limit = 3;

  const getMenuItems = (isShowLess: boolean) => {
    return isShowLess ? menuItems.slice(0, limit) : menuItems.slice(limit, menuItems.length);
  };

  return {
    showLessItemAmount,
    setShowLessItemAmount,
    limit,
    getMenuItems,
  };
};

export default useViewModel;
